import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots.svg",
  "use": "dots.svg-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dots.svg\"><rect x=\"2.5\" y=\"8.333\" width=\"3.333\" height=\"3.333\" rx=\"1.667\" fill=\"currentColor\" /><rect x=\"8.333\" y=\"8.333\" width=\"3.333\" height=\"3.333\" rx=\"1.667\" fill=\"currentColor\" /><rect x=\"14.167\" y=\"8.333\" width=\"3.333\" height=\"3.333\" rx=\"1.667\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol